export default __webpack_public_path__ + "static/media/icon_loading_circle.b2dca3a7.gif";